import { fmtMilli, sanitizeDecimal, signOf } from "../../lib/mshopCalc";

export const PAGE_BG = "bg-[#F4F3EF]";

export function NumField({ label, value, onChange, unit, big = false, placeholder = "0.000", testId }) {
    return (
        <label className="block">
            <span className="mb-2 block text-[15px] font-semibold text-neutral-800">{label}</span>
            <div className={`flex items-center justify-between rounded-2xl border border-[#DAD7CF] bg-[#F3F2EE] px-4 transition-colors focus-within:border-[#8A6A1F] focus-within:bg-white ${big ? "h-[72px]" : "h-16"}`}>
                <input
                    inputMode="decimal"
                    dir="ltr"
                    value={value}
                    onChange={(e) => onChange(sanitizeDecimal(e.target.value))}
                    placeholder={placeholder}
                    className={`w-full min-w-0 bg-transparent text-left font-numbers font-bold text-neutral-900 outline-none placeholder:text-neutral-400 ${big ? "text-3xl" : "text-xl"}`}
                    data-testid={testId}
                />
                <span className="shrink-0 ps-2 text-sm text-neutral-500">{unit}</span>
            </div>
        </label>
    );
}

export function NoteField({ label, value, onChange, testId }) {
    return (
        <label className="block">
            <span className="mb-2 flex items-baseline justify-between">
                <span className="text-[15px] font-semibold text-neutral-800">{label}</span>
                <span className="text-xs text-neutral-400">اختياري</span>
            </span>
            <input
                value={value}
                maxLength={200}
                onChange={(e) => onChange(e.target.value)}
                className="h-16 w-full rounded-2xl border border-[#DAD7CF] bg-[#F3F2EE] px-4 text-base outline-none transition-colors focus:border-[#8A6A1F] focus:bg-white"
                data-testid={testId}
            />
        </label>
    );
}

export function TicketDivider() {
    return (
        <div className="relative -mx-5 my-5 sm:-mx-7">
            <div className="border-t-2 border-dashed border-[#D9D6CE]" />
            <span className="absolute -right-3 top-1/2 h-6 w-6 -translate-y-1/2 rounded-full border border-[#E7E5DF] bg-[#F4F3EF]" />
            <span className="absolute -left-3 top-1/2 h-6 w-6 -translate-y-1/2 rounded-full border border-[#E7E5DF] bg-[#F4F3EF]" />
        </div>
    );
}

export function ResultRow({ label, value, strong = false, extra, testId }) {
    return (
        <div className={`flex items-center gap-3 ${strong ? "py-3" : "py-2"}`}>
            <span className={strong ? "text-xl font-bold text-neutral-900 sm:text-2xl" : "text-[15px] text-neutral-700 sm:text-lg"}>{label}</span>
            <span className="h-px flex-1 border-b border-dotted border-neutral-300" />
            {extra}
            <span
                dir="ltr"
                className={`font-numbers font-bold ${strong ? "text-2xl text-[#8A6A1F]" : "text-lg text-neutral-900"}`}
                data-testid={testId}
            >
                {fmtMilli(value)}
            </span>
        </div>
    );
}

export function ProfitBox({ value, hint, testId }) {
    const sg = value === null || value === undefined ? 0 : signOf(value);
    const tone = sg > 0
        ? "bg-[#E3F1E8] text-emerald-800 ring-emerald-200"
        : sg < 0 ? "bg-rose-50 text-rose-700 ring-rose-200" : "bg-[#EFEDE8] text-neutral-700 ring-neutral-200";
    return (
        <div className={`rounded-3xl p-5 ring-1 transition-colors ${tone}`} data-testid={testId} data-sign={sg > 0 ? "positive" : sg < 0 ? "negative" : "zero"}>
            <div className="text-base font-semibold">الفائدة</div>
            <div dir="ltr" className="mt-2 text-right font-numbers text-3xl font-black" data-testid={`${testId}-value`}>{fmtMilli(value)}</div>
            <div className="mt-2 text-sm opacity-75">{hint}</div>
        </div>
    );
}

export function FormActions({ onClear, onSave, saving, disabled, saveLabel, testPrefix }) {
    return (
        <div className="mt-5 flex gap-3">
            <button
                type="button"
                onClick={onClear}
                className="h-16 w-28 shrink-0 rounded-2xl border-2 border-[#D9D6CE] bg-white text-xl font-bold text-neutral-900 transition-colors hover:bg-neutral-50"
                data-testid={`${testPrefix}-clear-btn`}
            >
                مسح
            </button>
            <button
                type="button"
                onClick={onSave}
                disabled={disabled || saving}
                className="h-16 flex-1 rounded-2xl bg-[#1F1D1A] text-xl font-bold text-[#F3DFA2] transition-colors hover:bg-black disabled:bg-[#A3A19D] disabled:text-[#F1E6C8]"
                data-testid={`${testPrefix}-save-btn`}
            >
                {saving ? "جارٍ الحفظ..." : saveLabel}
            </button>
        </div>
    );
}
